import RichTextHeadline from 'components/shared/RichTextHeadline/RichTextHeadline';
import RichTextCopy from 'components/shared/RichTextCopy/RichTextCopy';
import { VideoPlayer, VideoPreview, VideoControls } from '../VideoPlayer';
import Media from 'components/shared/Media/Media';
import CTA from 'components/shared/CTA/CTA';
import { MediaCopyDividedProps } from './types';
import { liveUpdateAttrs } from 'libs/contentful/utils';
import { getColorway, getYMargins, cn } from 'utils/styles';

const MediaCopyDivided = ({
  sys,
  sectionName,
  headline,
  copy,
  color,
  desktopImage,
  mobileImage,
  video,
  cta,
  margins,
}: MediaCopyDividedProps) => {
  const hasPlayableVideo = video != null && (video.video != null || video.videoUrl != null);

  return (
    <section
      {...(sectionName != null && { id: encodeURIComponent(sectionName) })}
      className={`${getColorway(color)} ${getYMargins(margins)}`}>
      <div className="content-wrapper">
        {headline && (
          <div
            className={cn(
              'max-w-xl font-sans font-semibold sm:w-full text-center text-heading-md md:text-heading-lg mx-auto pb-15',
            )}
            {...liveUpdateAttrs(sys?.id, 'headline')}>
            <RichTextHeadline headline={headline} />
          </div>
        )}
        <div className="w-full flex flex-col sm:flex-row sm:justify-between gap-6 sm:gap-12 md:gap-32">
          <div className="flex-auto sm:max-w-[55%]">
            {hasPlayableVideo ? (
              <VideoPlayer
                video={video}
                testId="media-copy-video-player"
                {...liveUpdateAttrs(video.sys?.id, 'video')}
                classNames={{
                  wrapper: 'w-full h-full rounded-[20px] overflow-hidden',
                  player: 'object-cover',
                }}>
                <VideoPreview image={video.previewImage} showPreviewOnEnd />
                <VideoControls hideOnVideoStarted showOnVideoEnd position="center" />
              </VideoPlayer>
            ) : (
              <Media
                media={desktopImage}
                {...liveUpdateAttrs(sys?.id, 'desktopImage')}
                mobileMedia={mobileImage}
                sizes="(max-width: 900px) 100vw, 900px"
                className="block w-full rounded-none"
              />
            )}
          </div>
          <div className="flex-auto">
            <div {...liveUpdateAttrs(sys?.id, 'copy')}>
              {copy.items.map((item, i) => (
                <div
                  key={item.sys?.id ?? i}
                  className="sm:max-w-[450px] font-sans text-[24px] mt-6 after:block after:w-[55%] after:h-[3px] after:my-6 after:mx-auto after:border-[3px] after:border-solid after:border-current last:after:hidden">
                  <RichTextCopy copy={item.copy} />
                </div>
              ))}
            </div>
            {cta && (
              <div
                className="sm:max-w-[450px] font-sans text-[24px] text-center mt-20"
                {...liveUpdateAttrs(sys?.id, 'cta')}>
                <CTA cta={cta} />
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default MediaCopyDivided;
